import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {L} from "../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import getIncludedScienceLayers = L.tree.getIncludedScienceLayers;
import {IFeatureState} from "../services/feature_state";
import isSuitableForQuerying = L.tree.isSuitableForQuerying;
import {IFeaturesScope} from "./features";
import isQueryAble = L.tree.isQueryAble;
import {AreaReportFeatureKind, ReportKind} from "../services/ISharedFeatureState";


interface ILayerPickerScope extends IFeaturesScope {
    showReportLayersOnMap();
    isAReportingLayerNotTurnedOn(): boolean;
    availableScienceLayers() : Item[];
    activateLayer(item: Item);
    activateLayerReport(item: Item);
    isLayerIncludedInReport(item: Item): boolean;
    isLayerSuitableForCurrentReport(item: Item): boolean;
}

export class LayerPickerCtrl {
    public static $inject = [
        "$scope",
        'landcareMapService',
        'featureState'];

    constructor(protected $scope: ILayerPickerScope,
                protected mapService: IMapService,
                protected featureState: IFeatureState) {
        $scope.availableScienceLayers = () => getIncludedScienceLayers(this.mapService.treeData);

        $scope.isLayerSuitableForCurrentReport = (item: Item) => {
            let rp = this.featureState.sharedState().activeReport;
            if (rp && rp.kind == ReportKind.area && rp.featureKind == AreaReportFeatureKind.predefined && rp.sourceLayer) {
                return isSuitableForQuerying(rp.sourceLayer, item);
            }
            return isQueryAble(item);
        };

        $scope.activateLayer = (item) => {
            if (!item.checked) {
                item.checked = true;
                $scope['showSelected'](item, true, false);
            } else {
                let anyOthersChecked = $scope.availableScienceLayers().some((i) => i.checked && i !== item);
                if (anyOthersChecked) {
                    item.checked = false;
                    $scope['showSelected'](item, true, false);
                }
            }
        };

        $scope.activateLayerReport = (item) => {
            this.featureState.toggleIfLayerIsIncludedInReport(item, !$scope.isLayerIncludedInReport(item));
        };

        $scope.isLayerIncludedInReport = (item) => {
            return this.featureState.reportingLayers().indexOf(item) != -1;
        };

        $scope.isAReportingLayerNotTurnedOn = () => {
            return this.featureState.reportingLayers().some((l) => !l.checked);
        };

        $scope.showReportLayersOnMap = () => {
            this.featureState.reportingLayers().forEach((l) => {
                if (!l.checked) {
                    $scope.activateLayer(l);
                }
            })
        }
    }
}
